import { faKey, faUser } from '@fortawesome/pro-light-svg-icons';
import { NavBarMenuObject } from '../store/GlobalTypes';

export const SCHEDULER_ACCOUNT_DETAILS_TABS = {
  ACCOUNT_DETAILS: { text: 'Account details', icon: null },
  DEVICE_DETAILS: { text: 'Ōmcare details', icon: null },
  CARE_TEAM: { text: 'Care team', icon: null },
  MEDICATION_SCHEDULE: { text: 'Medication schedule', icon: null },
};

export const ADMIN_ACCOUNT_DETAILS_TABS = {
  ACCOUNT_DETAILS: { text: 'Account details', icon: null },
  DEVICE_DETAILS: { text: 'Ōmcare details', icon: null },
  CARE_TEAM: { text: 'Care team', icon: null },
};

export const ACCOUNT_DETAILS_ONLY = {
  ACCOUNT_DETAILS: { text: 'Account details', icon: null },
};

export const MY_ACCOUT_TABS = {
  PERSONAL_INFO: { text: 'Personal info', icon: faUser },
  CHANGE_PASSWORD: { text: 'Change password', icon: faKey },
};

export const REPORTING_TABS = {
  DASHBOARD: { text: 'Dashboard', icon: null },
  ADHERENCE: { text: 'Aggregate adherence', icon: null },
};

export const ONE_YEAR_IN_MSECONDS = 365 * 24 * 3600 * 1000;

export const FACILITY_ROLE = {
  FACILITY_ADMIN: 1,
  FACILITY_SCHEDULER: 2,
  FACILITY_CAREGIVER: 3,
  FACILITY_PATIENT: 4,
  FACILITY_NURSE: 5,
};

// Admin-only: ProtectedRoute keeps Caregiver/Nurse/Owner off /v2/patients/:id, so they can't reach this button.
export const VIDEO_CALL_PROVIDER_ROLE_IDS: number[] = [
  FACILITY_ROLE.FACILITY_ADMIN,
];

export const CARETEAM_ROLE = {
  PROFESSIONAL_CAREGIVER: 1,
  FAMILY_ADMIN: 2,
  FAMILY_CAREGIVER: 3,
  FAMILY_CONTACT: 4,
  FACILITY_SCHEDULER: 5,
};

export const PHARMACY_ROLE = {
  TECHNICIAN: 1,
};

export const US_STATES = [
  { id: 'AL', name: 'Alabama' },
  { id: 'AK', name: 'Alaska' },
  { id: 'AZ', name: 'Arizona' },
  { id: 'AR', name: 'Arkansas' },
  { id: 'CA', name: 'California' },
  { id: 'CO', name: 'Colorado' },
  { id: 'CT', name: 'Connecticut' },
  { id: 'DE', name: 'Delaware' },
  { id: 'DC', name: 'District of Columbia' },
  { id: 'FL', name: 'Florida' },
  { id: 'GA', name: 'Georgia' },
  { id: 'HI', name: 'Hawaii' },
  { id: 'ID', name: 'Idaho' },
  { id: 'IL', name: 'Illinois' },
  { id: 'IN', name: 'Indiana' },
  { id: 'IA', name: 'Iowa' },
  { id: 'KS', name: 'Kansas' },
  { id: 'KY', name: 'Kentucky' },
  { id: 'LA', name: 'Louisiana' },
  { id: 'ME', name: 'Maine' },
  { id: 'MD', name: 'Maryland' },
  { id: 'MA', name: 'Massachusetts' },
  { id: 'MI', name: 'Michigan' },
  { id: 'MN', name: 'Minnesota' },
  { id: 'MS', name: 'Mississippi' },
  { id: 'MO', name: 'Missouri' },
  { id: 'MT', name: 'Montana' },
  { id: 'NE', name: 'Nebraska' },
  { id: 'NV', name: 'Nevada' },
  { id: 'NH', name: 'New Hampshire' },
  { id: 'NJ', name: 'New Jersey' },
  { id: 'NM', name: 'New Mexico' },
  { id: 'NY', name: 'New York' },
  { id: 'NC', name: 'North Carolina' },
  { id: 'ND', name: 'North Dakota' },
  { id: 'OH', name: 'Ohio' },
  { id: 'OK', name: 'Oklahoma' },
  { id: 'OR', name: 'Oregon' },
  { id: 'PA', name: 'Pennsylvania' },
  { id: 'RI', name: 'Rhode Island' },
  { id: 'SC', name: 'South Carolina' },
  { id: 'SD', name: 'South Dakota' },
  { id: 'TN', name: 'Tennessee' },
  { id: 'TX', name: 'Texas' },
  { id: 'UT', name: 'Utah' },
  { id: 'VT', name: 'Vermont' },
  { id: 'VA', name: 'Virginia' },
  { id: 'WA', name: 'Washington' },
  { id: 'WV', name: 'West Virginia' },
  { id: 'WI', name: 'Wisconsin' },
  { id: 'WY', name: 'Wyoming' },
];

export const REACT_ERROR_CODES = {
  INVALID_SYNC_CODE: 1001,
  INVALID_PARAM: 1002,
};

export const AUTH_MESSAGES = {
  LIMIT_EXCEEDED: 'Attempt limit exceeded',
  FAILED_TOKEN_VALIDATION: 'Failed to validate token',
  EMAIL_VERIFICATION_SUCCESS: 'Email verification successful',
  EMAIL_ALREADY_VERIFIED: 'Your email has already been previously verified',
  EMAIL_VERIFICATION_REQUIRED: 'EMAIL_VERIFICATION_REQUIRED',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  MFA_REQUIRED: 'MFA_REQUIRED',
  PHONE_MFA_SETUP_REQUIRED: 'PHONE_MFA_SETUP_REQUIRED',
};

export const SOFTWARE_CHANNEL_ID = {
  STABLE: 1,
  BETA: 2,
};
export const NavBarMenus: NavBarMenuObject = {
  Users: {
    title: 'Users',
    path: '',
    options: [
      {
        title: 'Owners',
        path: '/owners',
      },
      {
        title: 'Engineers',
        path: '/engineers',
      },
    ],
  },
  Partners: {
    title: 'Partners',
    path: '',
    options: [
      {
        title: 'Facilities',
        path: '/facilities',
      },
      {
        title: 'Pharmacies',
        path: '/pharmacies',
      },
    ],
  },
  Devices: {
    title: 'Devices',
    path: '/devices',
    options: [],
  },
  Software: {
    title: 'Software',
    path: '',
    options: [
      {
        title: 'Versions',
        path: '/software',
      },
      {
        title: 'Deployments',
        path: '/softwareDeployment',
      },
    ],
  },

  CustomerMenu: {
    title: 'Customers',
    path: '',
    options: [
      {
        title: 'Omcare Customers',
        path: '/customers',
      },
      {
        title: 'Customer Care',
        path: '/customerCare',
      },
      {
        title: 'Pharmacy Tech',
        path: '/pharmacyTech',
      },
    ],
  },
  Customers: {
    // Removed the single menu
    title: 'Customers',
    path: '/customers',
    options: [],
  },
  Reporting: {
    title: 'Reporting',
    path: '/reporting',
    options: [],
  },
  Operations: {
    title: 'Operations',
    path: '/ops',
    options: [],
  },
  CallStats: {
    title: 'Call Stats',
    path: '/v2/call-stats',
    options: [],
  },
  MyFacility: {
    title: 'My Facility',
    path: '/facility',
    options: [],
  },
  Support: {
    title: 'Support',
    path: '/support',
    options: [],
  },
  Notifications: {
    title: 'Notifications',
    path: '/notifications',
    options: [],
  },
  Profile: {
    title: 'Profile',
    path: '',
    isCustomComponent: true,
    component: null,
    options: [
      {
        title: 'Profile Name',
        path: '/myAccount',
        isCustomComponent: true,
        component: null,
      },
      {
        title: 'My account',
        path: '/myAccount',
      },
      {
        title: 'Log out',
        path: '',
        onClick: null,
      },
    ],
  },
};

export const DEVICE_FAULT_CODES = {
  dispense_fault: 10, // device failed to dispense, needs maintenance
  update_fault: 20, // device failed to update, should resolve automatically
  adherence_sync_fault: 30, // medication is out of sync between omcare and the server, should resolve automatically
};

export const DATE_FORMAT = 'MM/DD/YYYY';

export const LONG_DATE_FORMAT = 'MMMM Do, YYYY';

export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

export const DATE_TIME_SECONDS_FORMAT = 'MM/DD/YYYY hh:mm:ss A';

export const careteamRoleOptions = [
  {
    label: 'Family admin',
    value: CARETEAM_ROLE.FAMILY_ADMIN,
  },
  {
    label: 'Family caregiver',
    value: CARETEAM_ROLE.FAMILY_CAREGIVER,
  },
  {
    label: 'Family contact',
    value: CARETEAM_ROLE.FAMILY_CONTACT,
  },
];

export const UNIFIED_FACILITY_ADMIN_ROLES = [
  FACILITY_ROLE.FACILITY_SCHEDULER,
  FACILITY_ROLE.FACILITY_ADMIN,
];

export const PRIVILEGE = {
  CUSTOMER_CARE: 2,
  ENGINEERING: 3,
  PHARMACY_TECH: 4,
};

export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  NON_BINARY: 10,
  DECLINE_TO_SAY: 90,
};

export const GENDER_LABELS: Record<number, string> = {
  1: 'Male',
  2: 'Female',
  10: 'Non-binary',
  90: 'Other',
};

export const AccountDelModalTypes = {
  ONLY_ADMIN_WARNING: 'OnlyAdminWarning',
  ASSIGN_ADMIN_MODAL: 'AssignAdminModal',
  INVITE_NEW_ADMIN_MODAL: 'InviteNewAdminModal',
  CONFIRM_DELETION_MODAL: 'ConfirmDeletionModal',
};

export const RELATIONSHIP_TO_OWNER = {
  FAMILY_ADMIN: 'family_admin',
  FAMILY_CAREGIVER: 'family_caregiver',
  FAMILY_CONTACT: 'family_contact',
  PROFESSIONAL_CAREGIVER: 'professional_caregiver',
  FACILITY_CAREGIVER: 'facility_caregiver',
  FACILITY_ADMIN: 'facility_admin',
} as const;

export type RelationshipToOwner =
  (typeof RELATIONSHIP_TO_OWNER)[keyof typeof RELATIONSHIP_TO_OWNER];

export enum UserRoles {
  UNDEFINED = 'undefined',
  CUSTOMER_CARE = 'customer_care',
  ENGINEERING = 'engineering',
  PHARMACY_TECH = 'pharamacy_tech',
  STANDARD = 'standard',
  NONE = 'none',
  FACILITY_ADMIN = 'Facility admin',
  FACILITY_SCHEDULER = 'Scheduler',
  FACILITY_CAREGIVER = 'Caregiver',
  FACILITY_OWNER = 'Owner',
  FACILITY_NURSE = 'Nurse',
  FACILITY_UNKNOWN = 'unknown',
}

// Roles allowed to edit a patient's details (OI-1586). Guards the Edit button on
// PatientDetails and mirrors the API's checkOwnerProfileEditPermission: customer
// care anywhere, facility admins for their own facility's patients. ENGINEERING
// is deliberately absent — the API 403s it.
export const PATIENT_EDIT_ROLES: UserRoles[] = [
  UserRoles.FACILITY_ADMIN,
  UserRoles.CUSTOMER_CARE,
];

// Roles allowed to see a med event's dispense images (OI-1368). ProtectedRoute
// already keeps Caregiver/Nurse/Owner/pharmacy techs off /v2/patients/:id; this
// additionally hides the "Medication images" tab from Scheduler and ENGINEERING.
export const MED_EVENT_IMAGE_ROLES: UserRoles[] = [
  UserRoles.FACILITY_ADMIN,
  UserRoles.CUSTOMER_CARE,
];

// Roles that see the survey "Insights" tab on the patient page (OI-1899) and the
// location page (OI-1928). UI-only gate, staged rollout: customer care validates
// the feature first; add a role here to release the tab to it. The APIs already
// serve Facility admin for their own patients, so that is the expected next
// entry. ProtectedRoute keeps restricted roles off both pages regardless.
export const INSIGHTS_VIEW_ROLES: UserRoles[] = [UserRoles.CUSTOMER_CARE];

export enum Status {
  Online = 'Online',
  Offline = 'Offline',
  Unassigned = 'Unassigned',
}

export enum SoftwareStatus {
  UpToDate = 'Up-to-date',
  NeedUpdating = 'Need updating',
  Unknown = 'Unknown',
}

export enum SurveyResponse {
  VeryHappy = 'Very happy',
  SomewhatHappy = 'Somewhat happy',
  SomewhatUnhappy = 'Somewhat unhappy',
  VeryUnhappy = 'Very unhappy',
}

// Mirrors SURVEY_TYPE in OmcareRestServer. Passed as ?survey_type_id= to
// GET /customers/:id/satisfaction_survey so CSAT views only get CSAT rows.
export enum SurveyType {
  HubOverallExperience = 1,
  HubDailyWellnessCheck = 2,
}

export const HUB_EXPERIENCE_SURVEY_RESPONSE: Record<number, string> = {
  1: 'Very unhappy',
  2: 'Somewhat unhappy',
  3: 'Somewhat happy',
  4: 'Very happy',
};

// Labels for the 1-5 daily wellness check ("How do you feel today?") scale.
// Mirrors HUB_WELLNESS_SURVEY_RESPONSE in OmcareRestServer.
export enum WellnessResponse {
  VeryBad = 'Very bad',
  Bad = 'Bad',
  Neutral = 'Neutral',
  Good = 'Good',
  VeryGood = 'Very good',
}

export const HUB_WELLNESS_SURVEY_RESPONSE: Record<number, string> = {
  1: WellnessResponse.VeryBad,
  2: WellnessResponse.Bad,
  3: WellnessResponse.Neutral,
  4: WellnessResponse.Good,
  5: WellnessResponse.VeryGood,
};

export enum MedStatusType {
  Administered = 'administered',
  AnsweredOutsideMedWindow = 'answered outside med window',
  Skipped = 'skipped',
  PastDue = 'past due',
  Missed = 'missed',
  Unknown = 'unknown',
}

// Keys mirror the backend enum verbatim — including the existing typos
// (`i_do_not_understood_directions`, `doctor_adviced_not_to_take`). Do not
// "fix" them here without coordinating a backend rename.
export const SKIPPED_REASON_MAPPING: Record<string, string> = {
  i_forgot: 'I forgot',
  i_do_not_understood_directions: 'I did not understand directions',
  too_many_medications: 'Too many medications',
  side_effects: 'Side effects',
  medication_not_working: 'Medication not working',
  doctor_adviced_not_to_take: 'Doctor advised not to take',
  reason_not_listed: 'Reason not listed',
};

export const MED_EVENT_STATUS_ID = {
  Prescribed: 10,
  Loaded: 20,
  Unloaded: 21,
  PreDispensed: 39,
  Dispensed: 30,
  DispenseFailed: 31,
  BagRemoved: 32,
  Skipped: 40,
  Administered: 50,
  Invalidated: 60,
  Missed: 70,
  DispensedButUnanswered: 73,
  PrescribedButUnanswered: 75,
  BagRemovedButUnanswered: 76,
  UnloadedButUnanswered: 77,
  PreDispensedButUnanswered: 79,
} as const;

export const EVENT_NAME_MAPPING: Record<number, string> = {
  [MED_EVENT_STATUS_ID.Prescribed]: 'Prescribed',
  [MED_EVENT_STATUS_ID.Loaded]: 'Loaded',
  [MED_EVENT_STATUS_ID.Unloaded]: 'Unloaded',
  [MED_EVENT_STATUS_ID.Dispensed]: 'Dispensed',
  [MED_EVENT_STATUS_ID.DispenseFailed]: 'Dispense Failed',
  [MED_EVENT_STATUS_ID.BagRemoved]: 'Bag Removed',
  [MED_EVENT_STATUS_ID.Skipped]: 'Skipped',
  [MED_EVENT_STATUS_ID.Administered]: 'Administered',
  [MED_EVENT_STATUS_ID.Invalidated]: 'Invalidated',
  [MED_EVENT_STATUS_ID.Missed]: 'Missed',
  [MED_EVENT_STATUS_ID.PreDispensed]: 'Pre-Dispensed',
  [MED_EVENT_STATUS_ID.DispensedButUnanswered]: 'Dispensed but Unanswered',
  [MED_EVENT_STATUS_ID.PrescribedButUnanswered]: 'Prescribed but Unanswered',
  [MED_EVENT_STATUS_ID.BagRemovedButUnanswered]: 'Bag Removed but Unanswered',
  [MED_EVENT_STATUS_ID.UnloadedButUnanswered]: 'Unloaded but Unanswered',
  [MED_EVENT_STATUS_ID.PreDispensedButUnanswered]:
    'Pre-Dispensed but Unanswered',
};

export enum IssueSeverity {
  HIGH = 'HIGH',
  LOW = 'LOW',
}

export enum DeviceActionType {
  Reboot = 'reboot',
  SoftwareUpdate = 'software_update',
  FactoryReset = 'factory_reset',
  DeleteHubDb = 'delete_hub_db',
  UnassignOwner = 'unassign_owner',
  LinkDeviceToOwner = 'LINK_DEVICE_TO_OWNER',
  EnvSwitch = 'env_switch',
}

export const ENV_SWITCH_TARGETS = ['production', 'staging', 'uat'] as const;
export type EnvSwitchTarget = (typeof ENV_SWITCH_TARGETS)[number];

export const ENV_SWITCH_REST_HOSTS: Record<EnvSwitchTarget, string> = {
  production: 'https://rest.omcare.com:443',
  staging: 'https://rest.staging.omcare.com:443',
  uat: 'https://rest.uat.omcare.com:443',
};

export const ENV_SWITCH_STORAGE_HOSTS: Record<EnvSwitchTarget, string> = {
  production: 'https://storage.omcare.com',
  staging: 'https://storage.staging.omcare.com',
  uat: 'https://storage.uat.omcare.com',
};

export const SOC_TYPE = {
  IMX6: 1,
  IMX8: 2,
};

export const SOC_ID_MAPPING: { [key: number]: string } = {
  1: 'imx6dl',
  2: 'imx8mp',
};

export const API_ACTION_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};
